/**
 * Created by wjjn3481 on 2017/4/19.
 */
const education = {
    resumeId: '', // 简历ID
    school: '', // 学校
    major: '', // 专业
    degree: '',    // 学历
    beginDate: '', //  开始时间
    endDate: '',  // 结束时间
    majorDesc: '' // 专业描述
}

const work = {
    resumeId: '', // 简历ID
    company: '',
    position: '',
    beginDate: '',
    endDate: ''
}

const project = {
    resumeId: '', // 简历ID
    name: '',
    role: '',
    description: '',
    responsibility: '',
    beginDate: '',
    endDate: ''
}

const skill = {
    resumeId: '', // 简历ID
    skill: '',
    proficiency: '',
    experience: ''
}

const experience = {
    resumeId: '', // 简历ID
    name: '',
    duration: '',
    achievement: ''
}

export {
    education,
    work,
    project,
    skill,
    experience
}


// WEBPACK FOOTER //
// ./src/views/resumeDetail/itemsData.js